import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AboutUs from "@/components/AboutUs";
import ProductCategories from "@/components/ProductCategories";
import CalendarioSemineSection from "@/components/CalendarioSemineSection";
import Brands from "@/components/Brands";
import WhyChooseUs from "@/components/WhyChooseUs";
import Gallery from "@/components/Gallery";
// import Testimonials from "@/components/Testimonials";
import PracticalInfo from "@/components/PracticalInfo";
import ContactSection from "@/components/ContactSection";

import Footer from "@/components/Footer";
import ChatBot from "@/components/ChatBot";
import SEO from "@/components/SEO";
import StructuredData from "@/components/StructuredData";
import BreadcrumbSchema from "@/components/BreadcrumbSchema";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Negozio per Animali, Pellet e Mangimi a Magione (PG)"
        description="Negozio per animali e agraria a Magione (PG): pet food, mangimi, pellet ENplus A1, legna da ardere, sementi e giardinaggio. Consegna a domicilio zona Trasimeno e Perugia. Dal 1983."
        canonical="/"
      />
      <BreadcrumbSchema items={[{ name: "Home", url: "/" }]} />
      <Navbar />
      <Hero />
      <AboutUs />
      <ProductCategories />
      <CalendarioSemineSection />
      <Brands />
      <WhyChooseUs />
      <Gallery />
      {/* <Testimonials /> */}
      <PracticalInfo />
      <ContactSection />
      <Footer />
      <ChatBot />
    </div>
  );
};

export default Index;
